import {defineStore} from "pinia";
import {AnalyticEventService} from "../services/analyticEvent.service";

export const useAnalyticEventStore = defineStore("analyticEvent", {
  state: () => ({
    analyticEventService: null,
    organizationId: "",
    session_uuid: "",
    userId: ""
  }),

  actions: {
    setOrganizationId(id) {
      if (id) {
        this.organizationId = id;
        this.analyticEventService = new AnalyticEventService(this.organizationId);
      } else {
        throw `Organization ID is not set: ${id}`;
      }
    },
  async logEvent(analyticEvent) {
      if (this.analyticEventService) {
        try {
          await this.analyticEventService.create(analyticEvent);
        } catch (error) {
          console.warn("Failed to log analytic event:", error);
          // Don't block user flow if analytics fail
        }
      } else {
        console.warn("Analytic service isn't currently set", this.organizationId);
      }
    },
  }
});
